import ExternalTemplate from './External';
export default ExternalTemplate;
